import { h } from 'preact'
import { FilterOptionDate } from './interfaces'
import ButtonControl from '../button-control'
import Icon from '../assets'
import DatePicker from '../date-picker'
import AnalyticsDateFormatter from './AnalyticsDateFormatter'

interface FilterDateRangeData {
    startDate: Date,
    endDate: Date,
    isDropdownOpen: boolean,
    toggleDropdown: (value: boolean) => void,
    onReset: () => void,
    onChange: () => void,
    onCustomDateChange: (dates: Date[]) => void,
    onPresetDateChange: (selectedDate: FilterOptionDate) => void,
    items: Array<FilterOptionDate>,
    selectedDate: any,
    selectedPresetId: string,
    isLoading: boolean
}

const DashboardDateRangeFilter = ({ startDate, endDate, isDropdownOpen, toggleDropdown, onReset, onCustomDateChange, onPresetDateChange, onChange, items, selectedDate, selectedPresetId, isLoading }: FilterDateRangeData) => {
  const today = new Date()

  return (
    <div className='filter-option filter-option-date'>
      <ButtonControl
        newStyle
        disabled={isLoading}
        title={<DateRangeFilterTitle startDate={startDate} endDate={endDate} isDropdownOpen={isDropdownOpen}/>}
        size='medium'
        class={`date-range-open-button filter-option-button ${isDropdownOpen ? 'dropdown-open' : ''} `}
        onClick={() => toggleDropdown(!isDropdownOpen)}
      />
      {isDropdownOpen &&
      <div className='overview__filters-box-container'>
        <div className='overview__filters-box filters-box-date-range'>
          <div className='overview__filters-box-content filters-box-content-date-range'>
            <div className='filter-preset-date-range'>
              { items.map(item => <div key={item.id} className='overview__filters-box-content preset-date-range-option' onClick={() => onPresetDateChange(item)}>
                <div className={`${selectedPresetId && item.id === selectedPresetId ? 'selected-date-range' : ''}`}>{item.label}</div>
                {selectedPresetId ? <div className='selected-date-range icon-check-wrapper'>
                  {item.id === selectedPresetId && <Icon icon='check' customClass='icon-check' />}
                </div> : null}
              </div>)}
            </div>
            <div className='custom-date-range-wrapper'>
              <div>
                <DatePicker allowPastDates allowRange
                  value={startDate}
                  maxDate={today}
                  defaultDateRange={[new Date(selectedDate.startDate), new Date(selectedDate.endDate)]}
                  disableInput
                  classes={['date-picker-start-date']}
                  onChange={(dates: Date[]) => onCustomDateChange(dates)} />
              </div>
            </div>
          </div>
          <div className='preset-date-range-action-buttons'>
            <hr />
            <div className='overview__filters-box-buttons'>
              <ButtonControl
                newStyle
                size='small'
                variant='brand'
                title='Apply'
                onClick={onChange}
              />
              <ButtonControl
                newStyle
                size='small'
                title='Cancel'
                onClick={onReset}
              />
            </div>
          </div>
        </div>
      </div>}
    </div>)
}

interface DateFilterTitleProps {
    startDate: Date,
    endDate: Date,
    isDropdownOpen: boolean
}

const DateRangeFilterTitle = ({ startDate, endDate, isDropdownOpen }: DateFilterTitleProps) => {
  const formattedStartDate = AnalyticsDateFormatter.displayFormattedDateInFilter(startDate)
  const formattedEndDate = AnalyticsDateFormatter.displayFormattedDateInFilter(endDate)
  const isSameDate = AnalyticsDateFormatter.isSameDay(formattedStartDate, formattedEndDate)
  return (<div>
    <span className={`dropdown-placeholder-text ${isDropdownOpen ? 'filter-dropdown-open' : ''}`}>Date</span>
    <span
      className={`dropdown-selected-placeholder date-range ${isDropdownOpen ? 'filter-dropdown-open' : ''}`}> {isSameDate ? `${formattedStartDate}` : `${formattedStartDate} - ${formattedEndDate}`}</span>
  </div>)
}

export default DashboardDateRangeFilter
